import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-graphite text-white font-body selection:bg-electric selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainSection data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonosSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <ComparisonTable data-id="element-7" />

      {/* More Testimonials (Section 10) */}
      <section className="py-16 bg-graphite border-y border-petroleum" data-id="element-8">
        <div className="container mx-auto px-4" data-id="element-9">
          <div className="text-center mb-12" data-id="element-10">
            <h2 className="text-2xl font-bold flex items-center justify-center gap-2" data-id="element-11">
              <span className="text-red-500" data-id="element-12">❤️</span> MÁS PROPIETARIOS QUE YA
              LO TIENEN
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-13">
            {[{
            in: 'PA',
            n: 'Pablo A.',
            l: 'Neuquén',
            t: 'El Manual del Emprendedor me permitió formalizar mis servicios. En 3 meses tengo 8 contratos de mantenimiento anual firmados.'
          }, {
            in: 'VL',
            n: 'Valentina L.',
            l: 'Rosario',
            t: 'El Tomo 4 me llegó justo cuando el diferencial empezó a saltar solo. Lo diagnostiqué yo, identifiqué la heladera con fuga y ahorré la visita del técnico.'
          }, {
            in: 'DM',
            n: 'Diego M.',
            l: 'Córdoba',
            t: 'Los protocolos de emergencia los imprimí y pegué en el tablero. La primera vez que los usé tardé 6 minutos en resolver lo que antes me costaba 40 minutos y un técnico.'
          }, {
            in: 'SC',
            n: 'Sofía C.',
            l: 'La Plata',
            t: 'El mapa del tablero del Bono 2 es lo que más cambió mi relación con la electricidad de mi casa. Por primera vez entiendo lo que tengo.'
          }].map((t, i) => <div key={i} className="bg-petroleum p-6 rounded-xl border border-white/5" data-id="element-14">
                <div className="flex items-center gap-3 mb-3" data-id="element-15">
                  <div className="w-10 h-10 rounded-full bg-electric/20 text-electric flex items-center justify-center font-bold text-sm" data-id="element-16">
                    {t.in}
                  </div>
                  <div data-id="element-17">
                    <div className="text-sm font-bold" data-id="element-18">{t.n}</div>
                    <div className="text-xs text-textsecondary" data-id="element-19">{t.l}</div>
                  </div>
                </div>
                <p className="text-sm text-textsecondary italic" data-id="element-20">"{t.t}"</p>
              </div>)}
          </div>
        </div>
      </section>

      <GuaranteeSection data-id="element-21" />
      <FAQSection data-id="element-22" />
      <CostTable data-id="element-23" />
      <FinalCTA data-id="element-24" />
      <Footer data-id="element-25" />
    </div>;
}